import { format } from 'date-fns';

/**
 * Format a date-time string to human-readable format
 */
export const formatDateTime = (dateString?: string): string => {
  if (!dateString) return 'N/A';
  try {
    return format(new Date(dateString), "MMM dd, yyyy 'at' HH:mm");
  } catch {
    return dateString;
  }
};

/**
 * Get badge color classes for registration status
 * Uses CSS custom properties for consistent theming
 */
export const getStatusColor = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'registered':
      return 'border bg-[var(--color-secondary-100)] text-[var(--color-secondary-700)] border-[var(--color-secondary-300)] hover:bg-[var(--color-secondary-300)]/50';
    case 'confirmed':
      return 'border bg-[var(--color-success-100)] text-[var(--color-success-700)] border-[var(--color-success-500)]/30 hover:bg-[var(--color-success-50)]';
    case 'attended':
      return 'border bg-[var(--color-primary-100)] text-[var(--color-primary-700)] border-[var(--color-primary-200)] hover:bg-[var(--color-primary-50)]';
    case 'cancelled':
      return 'border bg-[var(--color-error-100)] text-[var(--color-error-700)] border-[var(--color-error-500)]/30 hover:bg-[var(--color-error-100)]/80';
    case 'waitlisted':
      return 'border bg-[var(--color-warning-100)] text-[var(--color-warning-700)] border-[var(--color-warning-500)]/30 hover:bg-[var(--color-warning-100)]/80';
    case 'no_show':
      return 'border bg-[var(--color-neutral-300)]/20 text-[var(--color-neutral-700)] border-[var(--color-neutral-300)] hover:bg-[var(--color-neutral-300)]/40';
    default:
      return 'border bg-[var(--color-neutral-300)]/20 text-[var(--color-neutral-700)] border-[var(--color-neutral-300)] hover:bg-[var(--color-neutral-300)]/40';
  }
};

/**
 * Convert status string to human-readable label
 * Example: 'no_show' -> 'No Show', 'registered' -> 'Request sent'
 */
export const getStatusLabel = (status: string): string => {
  const normalizedStatus = status.toLowerCase();
  // Return translation key format
  return `statuses.${normalizedStatus}`;
};
